import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000/api';

const api = axios.create({ baseURL: API_URL, timeout: 15000, headers: { 'Content-Type': 'application/json' } });

let accessToken = localStorage.getItem('lp_access_token');
let refreshToken = localStorage.getItem('lp_refresh_token');

export const setTokens = (access, refresh) => {
  accessToken = access; refreshToken = refresh;
  if (access) localStorage.setItem('lp_access_token', access); else localStorage.removeItem('lp_access_token');
  if (refresh) localStorage.setItem('lp_refresh_token', refresh); else localStorage.removeItem('lp_refresh_token');
};

export const clearTokens = () => {
  accessToken = null; refreshToken = null;
  localStorage.removeItem('lp_access_token'); localStorage.removeItem('lp_refresh_token'); localStorage.removeItem('lp_user');
};

export const getStoredUser = () => { try { return JSON.parse(localStorage.getItem('lp_user')); } catch { return null; } };
export const storeUser = (user) => { localStorage.setItem('lp_user', JSON.stringify(user)); };

api.interceptors.request.use((config) => { if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`; return config; });

api.interceptors.response.use(r => r, async (error) => {
  if (error.response?.status === 401 && !error.config._retry && refreshToken) {
    error.config._retry = true;
    try {
      const { data } = await axios.post(`${API_URL}/auth/refresh`, { refreshToken });
      setTokens(data.accessToken, data.refreshToken);
      error.config.headers.Authorization = `Bearer ${data.accessToken}`;
      return api(error.config);
    } catch { clearTokens(); window.location.href = '/'; }
  }
  return Promise.reject(error);
});

export const authApi = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  me: () => api.get('/auth/me'),
  logout: () => api.post('/auth/logout', { refreshToken }),
};

export const licensesApi = {
  stats: () => api.get('/licenses/stats'),
  organizations: (params) => api.get('/licenses/organizations', { params }),
  getOrg: (id) => api.get(`/licenses/organizations/${id}`),
  issue: (data) => api.post('/licenses/issue', data),
  update: (id, data) => api.put(`/licenses/${id}`, data),
  revoke: (id) => api.delete(`/licenses/${id}`),
  createOrg: (data) => api.post('/licenses/create-org', data),
};

export default api;
